exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table th div[data-v-a6093cbc]{padding-left:0;padding-right:0}", ""]);

// exports
